var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2417 14.6558C24.5848 16.9989 24.5848 20.7979 22.2417 23.1411",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0701 11.8274C28.9753 15.7326 28.9753 22.0643 25.0701 25.9695",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8214 14L3.82144 7L2.40723 8.41421L25.0346 31.0416L26.4489 29.6274L17.9997 21.1783V8L11.9997 14H10.8214ZM11.9997 24L17.9997 30V26.8284L5.99971 14.8284V24H11.9997Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.ffb99c592caba7d668394d1784cd01dd.svg";
export { ForwardRef as ReactComponent };